// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Offline_pageWrapper__rF-ZV","imgWrapper":"Offline_imgWrapper__BqeyV","title":"Offline_title__yqx8E","subtitle":"Offline_subtitle__qEJAJ"};